import * as React from 'react';

import { styled } from '@mui/material/styles';
import Tooltip, { tooltipClasses } from "@mui/material/Tooltip";
import { isMobile } from 'react-device-detect';

export const LightTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} classes={{ popper: className }} />
  ))(({ theme }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
      marginTop: isMobile ? "0 !important" : undefined,
      backgroundColor: "#fff",
      color: theme.palette.neutral.main,
      fontSize: 12,
      border: '1px solid',
      borderColor: theme.palette.neutral.light,
      width: '180px',
      padding: '10px'
    },

  }));